// Google My Business Categories - Common business categories
// This list includes the most popular GMB categories across different industries

export const GMB_CATEGORIES = [
  // Food & Dining
  'Restaurant',
  'Fast Food Restaurant',
  'Pizza Restaurant',
  'Italian Restaurant',
  'Chinese Restaurant',
  'Mexican Restaurant',
  'Japanese Restaurant',
  'Indian Restaurant',
  'Thai Restaurant',
  'American Restaurant',
  'Cafe',
  'Coffee Shop',
  'Bakery',
  'Bar',
  'Pub',
  'Wine Bar',
  'Cocktail Bar',
  'Sports Bar',
  'Breakfast Restaurant',
  'Brunch Restaurant',
  'Lunch Restaurant',
  'Dinner Restaurant',
  'Food Truck',
  'Catering Service',
  
  // Retail
  'Clothing Store',
  'Shoe Store',
  'Electronics Store',
  'Furniture Store',
  'Home Goods Store',
  'Gift Shop',
  'Jewelry Store',
  'Book Store',
  'Toy Store',
  'Sporting Goods Store',
  'Convenience Store',
  'Grocery Store',
  'Supermarket',
  'Department Store',
  'Boutique',
  'Thrift Store',
  'Antique Store',
  'Art Gallery',
  'Pet Store',
  'Florist',
  'Garden Center',
  'Hardware Store',
  'Auto Parts Store',
  'Bicycle Shop',
  
  // Health & Wellness
  'Doctor',
  'Dentist',
  'Hospital',
  'Medical Clinic',
  'Urgent Care Center',
  'Pharmacy',
  'Physical Therapist',
  'Chiropractor',
  'Massage Therapist',
  'Acupuncturist',
  'Nutritionist',
  'Yoga Studio',
  'Gym',
  'Fitness Center',
  'Spa',
  'Hair Salon',
  'Barber Shop',
  'Nail Salon',
  'Beauty Salon',
  'Tattoo Shop',
  
  // Professional Services
  'Lawyer',
  'Attorney',
  'Accountant',
  'Financial Planner',
  'Insurance Agency',
  'Real Estate Agent',
  'Real Estate Agency',
  'Consultant',
  'Marketing Agency',
  'Advertising Agency',
  'Web Designer',
  'Graphic Designer',
  'Photographer',
  'Videographer',
  'Event Planner',
  'Wedding Planner',
  'Notary Public',
  
  // Home Services
  'Plumber',
  'Electrician',
  'HVAC Contractor',
  'Roofing Contractor',
  'General Contractor',
  'Carpenter',
  'Painter',
  'Landscaper',
  'Lawn Care Service',
  'Cleaning Service',
  'Maid Service',
  'Pest Control Service',
  'Locksmith',
  'Appliance Repair Service',
  'Computer Repair Service',
  'Cell Phone Repair Service',
  'Moving Company',
  'Storage Facility',
  
  // Automotive
  'Auto Repair Shop',
  'Car Dealer',
  'Used Car Dealer',
  'Car Wash',
  'Gas Station',
  'Tire Shop',
  'Auto Body Shop',
  'Auto Detailing Service',
  'Motorcycle Dealer',
  'Motorcycle Repair Shop',
  'Towing Service',
  'Car Rental Agency',
  
  // Education
  'School',
  'Elementary School',
  'Middle School',
  'High School',
  'College',
  'University',
  'Preschool',
  'Tutoring Service',
  'Music School',
  'Dance School',
  'Martial Arts School',
  'Driving School',
  'Language School',
  
  // Entertainment & Recreation
  'Movie Theater',
  'Bowling Alley',
  'Amusement Park',
  'Museum',
  'Zoo',
  'Aquarium',
  'Night Club',
  'Comedy Club',
  'Concert Hall',
  'Theater',
  'Park',
  'Playground',
  'Recreation Center',
  'Golf Course',
  'Mini Golf Course',
  'Arcade',
  
  // Lodging
  'Hotel',
  'Motel',
  'Bed & Breakfast',
  'Resort',
  'Hostel',
  'Vacation Home Rental',
  'RV Park',
  'Campground',
  
  // Travel & Transportation
  'Airport',
  'Train Station',
  'Bus Station',
  'Taxi Service',
  'Limousine Service',
  'Travel Agency',
  'Tour Agency',
  'Tourist Attraction',
  'Landmark',
  
  // Financial Services
  'Bank',
  'Credit Union',
  'ATM',
  'Investment Service',
  'Loan Agency',
  'Mortgage Broker',
  
  // Religious
  'Church',
  'Mosque',
  'Temple',
  'Synagogue',
  'Religious Organization',
  
  // Community & Government
  'Library',
  'Post Office',
  'Police Station',
  'Fire Station',
  'City Hall',
  'Community Center',
  'Non-Profit Organization',
  'Charity',
  
  // Pet Services
  'Veterinarian',
  'Animal Hospital',
  'Pet Groomer',
  'Pet Boarding Service',
  'Dog Trainer',
  'Pet Sitter',
  
  // Children's Services
  'Day Care Center',
  'After School Program',
  'Summer Camp',
  "Children's Party Service",
  
  // Technology
  'Software Company',
  'IT Support',
  'Computer Store',
  'Electronics Repair Service',
  'Data Recovery Service',
  
  // Manufacturing & Wholesale
  'Manufacturer',
  'Wholesale Distributor',
  'Warehouse',
  'Factory',
  
  // Agriculture
  'Farm',
  "Farmer's Market",
  'Agricultural Cooperative',
  
  // Other Services
  'Dry Cleaner',
  'Laundromat',
  'Tailor',
  'Courier Service',
  'Shipping Service',
  'Funeral Home',
  'Cemetery',
  'Self-Storage Facility',
  'Parking Lot',
  'Parking Garage',
  'Car Sharing Location',
  'Bike Sharing Station'
];

// Sort alphabetically for better UX
export const SORTED_GMB_CATEGORIES = [...GMB_CATEGORIES].sort();

export default SORTED_GMB_CATEGORIES;

